import { ProductionDashboard } from "@features/production/components/ProductionDashboard";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Activity } from "lucide-react";

export const Route = createFileRoute("/_app/production/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.DASHBOARD.VIEW),
  staticData: {
    title: "Production",
    icon: Activity,
    tab_icon: Activity,
    permission: PERMISSIONS.PRODUCTION.DASHBOARD.VIEW,
    module: "production",
    section: "Production",
    order: 10,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Tableau de bord Production",
  },
  component: ProductionDashboard,
});
